import axios, { AxiosRequestConfig, Method } from "axios";
import qs from "qs";
import { useAuthStore } from "../store/authStore";

export const BASE_URL = "https://www.fiestr.com:5001/api"; // add to .env file when having different environments
interface ApiHandlerParams {
  endpoint: string;
  method: Method;
  params?: Record<string, any>;
  mockData?: boolean;
  mockDataApiKey?: string;
  authorization?: boolean;
  token?: string;
  responseType?: AxiosRequestConfig["responseType"];
}

const apiHandler = async ({
  endpoint,
  method,
  params = {},
  authorization = false,
  token,
  responseType,
}: ApiHandlerParams) => {
  try {
    let globalToken = null;
    let authToken = null;
    if (authorization) {
      globalToken = useAuthStore.getState().token;
      authToken = token || globalToken;
    }

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    if (authToken) {
      headers["Authorization"] = `Bearer ${authToken}`;
    }

    const config = {
      method,
      url: `${BASE_URL}${endpoint}`,
      headers,
      data: method !== "GET" ? params : undefined,
      params: method === "GET" ? params : undefined,
      paramsSerializer: {
        serialize: (params: Record<string, any>) =>
          qs.stringify(params, { arrayFormat: "repeat" }),
      },
      responseType,
    };

    const response = await axios(config);

    return response.data;
  } catch (error: any) {
    console.error("Error en la petición:", error.response || error.message);
    throw error.response?.data || error;
  }
};

export default apiHandler;
